import AssertionEntity from '../../lib/FormValidator/Assertion/AssertionEntity';
import AssertionItem from '../../lib/FormValidator/Assertion/AssertionItem';
export class JugadorOfflineAssertions extends AssertionEntity {
  private constructor() {
    super();
  }

  static build() {
    const instance = new this();
    instance.addAssertionForName();
    instance.addAssertionForLastName();
    instance.addAssertionForDocumentType();
    instance.addAssertionForDocumentNum();
    return instance;
  }

  addAssertionForName(key = 'jugo_nombre') {
    this.defineAssertionForProperty(
      key,
      AssertionItem.forClosure(
        (value) => {
          return value !== '';
        },
        key,
        'Nombre es obligatorio'
      )
    );
  }

  addAssertionForLastName(key = 'jugo_apellido') {
    this.defineAssertionForProperty(
      key,
      AssertionItem.forClosure(
        (value) => {
          return value !== '';
        },
        key,
        'Apellido es obligatorio'
      )
    );
  }

  addAssertionForDocumentType(key = 'jugo_tipo_doc') {
    this.defineAssertionForProperty(
      key,
      AssertionItem.forClosure(
        (value) => {
          return value;
        },
        key,
        'Tipo de Documento es obligatorio'
      )
    );
  }

  addAssertionForDocumentNum(key = 'jugo_nro_doc') {
    this.defineAssertionForProperty(
      key,
      AssertionItem.forClosure(
        (value) => {
          return value !== '';
        },
        key,
        'Número de Documento es obligatorio'
      )
    );
  }
}
